/* Chewise Size Guide
   Product data arrives from the Liquid-rendered JSON in sections/size-guide.liquid
   (#cw-catalog = the three size collections, #cw-bundles = Bundle & Save).
   Nothing about prices, colours or stock is hardcoded here. */
(function(){
var META={
 small:{label:"Small",weight:"under 20 lbs",open:1.0,hue:"#229fe4",coll:"/collections/small-size-for-20lbs"},
 standard:{label:"Standard",weight:"20\u201370 lbs",open:1.1,hue:"#035ca3",coll:"/collections/chewise"},
 xl:{label:"Extra Large",weight:"over 70 lbs",open:1.6,hue:"#eb4f45",coll:"/collections/extra-large-size-for-70lbs"}};
var HEX={Blue:"#3f7fc1",Teal:"#3fa89e",Mint:"#3fa89e",Purple:"#8b6fbf",Pink:"#e58aa4",
 Yellow:"#f2c230",Orange:"#e08a3c",Green:"#4a9e6a",Red:"#d94f45",Grey:"#8c9299",Gray:"#8c9299"};
var ORDER=["Blue","Teal","Purple","Pink","Yellow","Orange"];

function readJSON(id){try{return JSON.parse(document.getElementById(id).textContent)}catch(e){return null}}
var RAW=readJSON("cw-catalog")||{}, RAWB=readJSON("cw-bundles")||{};

var CATALOG={};
["small","standard","xl"].forEach(function(k){
  var m=META[k];
  var list=(RAW[k]||[]).map(function(p){
    return {name:p.color,hex:HEX[p.color]||"#9aa7b1",vid:p.id,price:p.price,
            img:p.image,url:p.url,ok:!!p.available};
  }).sort(function(a,b){
    var i=ORDER.indexOf(a.name), j=ORDER.indexOf(b.name);
    return (i<0?99:i)-(j<0?99:j);
  });
  CATALOG[k]={label:m.label,weight:m.weight,open:m.open,hue:m.hue,coll:m.coll,colors:list};
});
var BUNDLES={}, FAMILY=null;
["2","3","4"].forEach(function(n){ if(RAWB[n]) BUNDLES[n]={t:n+"-Dog Bundle",p:RAWB[n].price,vid:RAWB[n].id,url:RAWB[n].url}; });
if(RAWB.family) FAMILY={t:"Family Bundle \u2014 Holder + Freeze Bowl",p:RAWB.family.price,vid:RAWB.family.id,url:RAWB.family.url};

var BREEDS=[["Chihuahua",5],["Yorkshire Terrier",6],["Pomeranian",6],["Maltese",6],["Toy Poodle",6],
["Papillon",8],["Miniature Pinscher",9],["Miniature Dachshund",10],["Shih Tzu",12],["Bichon Frise",13],
["Jack Russell Terrier",15],["Cavalier King Charles Spaniel",15],["Cavapoo",15],["Miniature Schnauzer",15],
["Pug",17],["Boston Terrier",18],["Mini Goldendoodle",22],["Shiba Inu",22],["Beagle",24],
["French Bulldog",25],["Pembroke Welsh Corgi",27],["Cocker Spaniel",28],["Whippet",32],
["Staffordshire Bull Terrier",35],["Border Collie",40],["Australian Cattle Dog",40],
["Springer Spaniel",45],["Siberian Husky",50],["Samoyed",50],["Australian Shepherd",50],["Bulldog",50],
["American Pit Bull Terrier",55],["Standard Poodle",55],["Dalmatian",55],["Basset Hound",55],["Vizsla",55],
["Chow Chow",60],["Goldendoodle",60],["Belgian Malinois",65],["Boxer",65],["Golden Retriever",68],
["Labrador Retriever",70],["Weimaraner",70],["German Shepherd",80],["Doberman Pinscher",80],
["Rhodesian Ridgeback",80],["Bernese Mountain Dog",95],["Akita",100],["Cane Corso",100],
["Great Pyrenees",100],["Rottweiler",105],["Newfoundland",130],["Great Dane",130],
["Saint Bernard",150],["Mastiff",175]];

var POWER=[{id:"gentle",n:"Gentle",d:"Nibbles away. One stick lasts for days."},
           {id:"medium",n:"Average",d:"Steady worker, finishes in a sitting."},
           {id:"strong",n:"Demolition expert",d:"Gone in minutes. Toys don't survive the week."}];
var CHEWS=[{id:"bully",n:"Bully sticks",d:"The classic. Works in every size.",fit:1},
           {id:"yak",n:"Yak cheese / collagen",d:"Hard, round, grips well.",fit:1},
           {id:"trachea",n:"Beef trachea or gullet",d:"Softer, still grips.",fit:1},
           {id:"flat",n:"Pig ears / flat chews",d:"Nothing round to bite into.",fit:0},
           {id:"hard",n:"Antlers, hooves, nylon",d:"Too hard and too wide.",fit:0},
           {id:"mixed",n:"A bit of everything",d:"We'll size for the thickest.",fit:1}];
var THICK=[{id:"thin",n:"Thin",d:'Up to 0.5" — pencil-ish',max:0.5},
           {id:"std",n:"Standard",d:'0.5–0.75" — the usual',max:0.75},
           {id:"thick",n:"Thick",d:'0.75–1" — chunky',max:1.0},
           {id:"jumbo",n:"Jumbo+",d:'Over 1" — thumb and up',max:1.25},
           {id:"unknown",n:"Not sure",d:"Size me on weight",max:null}];

/* --- rules --- */
function decide(S){
  var w=S.weight, out={why:[],notes:[]};
  var size = w<20 ? "small" : (w<=70 ? "standard" : "xl");
  out.why.push("At <b>"+w+" lbs</b>"+(S.breed?" ("+S.breed+")":"")+", your dog sits in the <b>"+CATALOG[size].label+"</b> range ("+CATALOG[size].weight+").");

  var band = (w>=15&&w<22) ? ["small","standard"] : ((w>=60&&w<=80) ? ["standard","xl"] : null);
  if(band){
    var before=size;
    if(S.power==="strong") size=band[1];
    else if(S.power==="gentle") size=band[0];
    if(size!==before){
      out.why.push(w+" lbs is right on the border, and a "+(S.power==="strong"?"demolition expert sizes <b>up</b>":"gentle chewer sizes <b>down</b>")+" → <b>"+CATALOG[size].label+"</b>.");
    }else{
      out.why.push(w+" lbs is on the border between two sizes; an average chewer stays with <b>"+CATALOG[size].label+"</b>.");
    }
  }else if(S.power==="strong"&&size==="small"){
    out.notes.push({lv:"warn",t:"Small dog, big energy",
      m:"Small is still the right size — the holder has to suit the mouth, not the enthusiasm. Keep sessions short, supervise, and swap the stub out early."});
  }

  var chew=find(CHEWS,S.chew), th=find(THICK,S.thick);
  if(chew&&!chew.fit){
    out.notes.push({lv:"stop",t:chew.n+" won't work in a holder",
      m:"There's nothing round for the metal teeth to bite into. Pair your Chewise with bully sticks, yak cheese chews, collagen sticks or beef trachea instead."});
  }
  if(th&&th.max){
    var open=CATALOG[size].open;
    if(th.max>open){
      if(size==="small"){
        out.notes.push({lv:"stop",t:"Your chew is thicker than your dog's size",
          m:"Jumbo sticks run 1–1.25\", and the Small opening is 1.0\". Sizing up to Standard only buys you 0.1\" — it won't fix it. The honest answer: keep the Small holder and buy Standard-cut sticks. An XL holder on a "+w+" lb dog is more holder than mouth."});
        out.why.push("Jumbo sticks won't clear the 1.0\" opening — see the note below.");
      }else{
        size="xl";
        out.why.push("Jumbo sticks run past 1.1\", so only the <b>1.6\" Extra Large</b> opening clears them.");
        out.notes.push({lv:"warn",t:"Your chew picked this size, not your dog",
          m:"By weight you'd be Standard. Jumbo sticks are the reason we moved you up. Feeding Standard-cut sticks instead? Go back a step and pick Standard — it'll suit your dog better."});
      }
    }else{
      out.why.push("Your usual chew ("+th.d.split("—")[0].trim()+") clears the "+CATALOG[size].open.toFixed(1)+"\" opening comfortably.");
    }
    if(size==="xl"&&th.max<=0.5){
      out.notes.push({lv:"warn",t:"Thin sticks in a big opening",
        m:"The 1.6\" opening is built for thick chews. A thin stick will still lock in, but tighten it firmly and check it can't be pulled out by hand."});
    }
  }
  out.size=size; return out;
}
function find(a,id){for(var i=0;i<a.length;i++)if(a[i].id===id)return a[i];return null;}

/* --- render --- */
var S={breed:null,weight:null,power:null,chew:null,thick:null,dogs:1,color:0},step=0;
var body=document.getElementById("cwBody");
var bars=document.querySelectorAll(".cw-steps i");
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];});}

function nav(ok,label,skip){
  return '<div class="cw-nav">'+
   '<button class="cw-link" data-act="back"'+(step===0?' style="visibility:hidden"':'')+'>&lsaquo; Back</button>'+
   '<span style="display:flex;gap:12px;align-items:center">'+
   (skip?'<button class="cw-link" data-act="skip">Skip</button>':'')+
   '<button class="cw-btn" data-act="next"'+(ok?'':' disabled')+'>'+(label||"Next")+'</button></span></div>';
}
function opts(list,key,cols){
  return '<div class="cw-opts c'+cols+'">'+list.map(function(o){
    return '<button class="cw-opt'+(S[key]===o.id?" on":"")+'" data-pick="'+key+'" data-val="'+o.id+'">'+
      '<b>'+esc(o.n)+'</b><span>'+esc(o.d)+'</span></button>';}).join("")+'</div>';
}
function render(){
  for(var i=0;i<bars.length;i++) bars[i].className = i<=step ? "on" : "";
  [stepDog,stepPower,stepChew,stepResult][step]();
  }

function stepDog(){
  body.innerHTML=
   '<p class="cw-q">First, who are we sizing?</p>'+
   '<p class="cw-qsub">Pick a breed and we\'ll fill in a typical adult weight — or just type the weight yourself.</p>'+
   '<div class="cw-field cw-breed"><label for="cwBreed">Breed</label>'+
   '<input type="text" id="cwBreed" autocomplete="off" placeholder="Start typing… Golden, Corgi, Frenchie" value="'+(S.breed?esc(S.breed):"")+'">'+
   '<div class="cw-sugg" id="cwSugg"></div></div>'+
   '<div class="cw-row">'+
     '<div class="cw-field"><label for="cwW">Adult weight (lbs)</label>'+
     '<input type="number" id="cwW" min="2" max="250" placeholder="45" value="'+(S.weight||"")+'"></div>'+
     '<div class="cw-field"><label for="cwD">How many dogs at home?</label>'+
     '<input type="number" id="cwD" min="1" max="6" value="'+S.dogs+'"></div>'+
   '</div>'+nav(!!S.weight);
  var bq=document.getElementById("cwBreed"),sg=document.getElementById("cwSugg"),wq=document.getElementById("cwW");
  bq.addEventListener("input",function(){
    var q=bq.value.trim().toLowerCase();
    if(!q){sg.className="cw-sugg";return;}
    var rank=function(b){var en=b[0].toLowerCase();
      if(en.indexOf(q)===0)return 0;
      if(en.split(/[\s-]/).some(function(w){return w.indexOf(q)===0}))return 1;
      return 2;};
    var hits=BREEDS.filter(function(b){return b[0].toLowerCase().indexOf(q)>-1})
      .sort(function(a,b){return rank(a)-rank(b)}).slice(0,7);
    if(!hits.length){sg.className="cw-sugg";return;}
    sg.innerHTML=hits.map(function(b){
      return '<button type="button" data-w="'+b[1]+'" data-n="'+esc(b[0])+'"><span>'+esc(b[0])+'</span><em>~'+b[1]+' lbs</em></button>';}).join("");
    sg.className="cw-sugg on";
  });
  sg.addEventListener("click",function(e){
    var b=e.target.closest("button"); if(!b)return;
    S.breed=b.getAttribute("data-n"); S.weight=+b.getAttribute("data-w");
    bq.value=S.breed; wq.value=S.weight; sg.className="cw-sugg";
    body.querySelector('[data-act="next"]').disabled=false;
  });
  wq.addEventListener("input",function(){
    S.weight=wq.value?+wq.value:null; if(!bq.value)S.breed=null;
    body.querySelector('[data-act="next"]').disabled=!S.weight;
  });
  document.getElementById("cwD").addEventListener("input",function(e){S.dogs=Math.max(1,+e.target.value||1)});
  if(!window.__cwDoc){window.__cwDoc=1;
    document.addEventListener("click",function(e){
      var s=document.getElementById("cwSugg");
      if(s&&!s.contains(e.target)&&e.target.id!=="cwBreed")s.className="cw-sugg";});}
}
function stepPower(){
  body.innerHTML='<p class="cw-q">How hard does it go?</p>'+
   '<p class="cw-qsub">This only changes the answer if your dog is sitting on a size border.</p>'+
   opts(POWER,"power",3)+nav(!!S.power,null,true);
}
function stepChew(){
  body.innerHTML='<p class="cw-q">What do you actually feed?</p>'+
   '<p class="cw-qsub">Whether the chew fits the opening is the one thing that can override your dog\'s weight.</p>'+
   opts(CHEWS,"chew",3)+
   '<p class="cw-q" style="font-size:19px;margin:24px 0 4px">And roughly how thick?</p>'+
   '<p class="cw-qsub" style="margin-bottom:12px">Eyeball it against your thumb if you\'re not sure.</p>'+
   opts(THICK,"thick",4)+nav(!!(S.chew&&S.thick),"See my size",true);
}
function stepResult(){
  if(!S.power)S.power="medium"; if(!S.chew)S.chew="bully"; if(!S.thick)S.thick="unknown";
  var r=decide(S), sz=CATALOG[r.size];
  var live=sz.colors.filter(function(c){return c.ok});
  if(!live.length){ S.color=-1; }
  else if(S.color<0||S.color>=sz.colors.length||!sz.colors[S.color].ok) S.color=sz.colors.indexOf(live[0]);
  var cur=(S.color>=0?sz.colors[S.color]:null)||null, price=cur?cur.price:0;
  var bd = (S.dogs>=2&&S.dogs<=4)?BUNDLES[S.dogs]:null;

  var buy;
  if(!cur){
    buy = '<div class="cw-note"><b>Out of stock</b>Every '+esc(sz.label)+' colour is sold out right now.</div>'+
          '<a class="cw-btn cw-btn--ghost cw-btn--block" href="'+sz.coll+'">See '+esc(sz.label)+' holders</a>';
  }else{
    buy = '<div class="cw-buy">'+
      (cur.img?'<img class="cw-shot" src="'+cur.img+'" alt="'+esc(sz.label)+' '+esc(cur.name)+' bully stick holder" loading="lazy" onerror="this.style.display=\'none\'">':'')+
      '<div style="flex:1;min-width:210px">'+
        '<h4 style="font-size:17px;margin-bottom:8px">Pick a color</h4>'+
        (live.length<=2?'<p class="cw-muted" style="margin:0 0 8px">'+esc(sz.label)+' comes in '+live.length+' color'+(live.length===1?'':'s')+' right now.</p>':'')+
        '<div class="cw-swatches">'+sz.colors.map(function(c,i){
           return '<button class="cw-sw'+(i===S.color?" on":"")+(c.ok?"":" off")+'" style="background:'+c.hex+'" '+
             'data-color="'+i+'" title="'+esc(c.name)+(c.ok?"":" — sold out")+'"'+(c.ok?"":" disabled")+'></button>'}).join("")+'</div>'+
        '<p class="cw-muted" style="margin:9px 0 0">'+esc(cur.name)+'</p>'+
        '<div class="cw-price">$'+price.toFixed(2)+'</div>'+
      '</div></div>'+
      '<button class="cw-btn cw-btn--coral cw-btn--block" style="margin-top:16px" data-cart="'+cur.vid+'">Add '+esc(sz.label)+' '+esc(cur.name)+' to cart</button>'+
      '<p class="cw-muted" style="text-align:center;margin-top:10px">Free shipping over $35 · 30-day worry-free returns</p>';
  }

  body.innerHTML=
   '<div style="margin:-20px -26px 0"><div class="cw-res__hero" style="background:'+sz.hue+'">'+
     '<div class="lab">Your match</div><div class="sz">'+esc(sz.label)+'</div>'+
     '<p>'+sz.open.toFixed(1)+'" opening &nbsp;·&nbsp; for dogs '+esc(sz.weight)+'</p></div></div>'+
   '<div style="padding-top:20px">'+
   '<ul class="cw-why">'+r.why.map(function(x){return "<li><span>"+x+"</span></li>"}).join("")+'</ul>'+
   r.notes.map(function(n){return '<div class="cw-note'+(n.lv==="stop"?" cw-note--stop":"")+'"><b>'+esc(n.t)+'</b>'+esc(n.m)+'</div>'}).join("")+
   (bd?'<div class="cw-upsell"><b>'+S.dogs+' dogs at home?</b> The '+esc(bd.t)+' is $'+bd.p.toFixed(2)+' and lets you swap sizes and colors — so your other dog gets their own fit too.'+
       '<div><button class="cw-btn" style="margin-top:10px;padding:10px 18px;font-size:15px" data-cart="'+bd.vid+'">Add the bundle</button></div></div>':'')+
   buy+
   (!bd&&FAMILY?'<div class="cw-upsell" style="border-color:#229fe4;background:#eef7fd"><b>Often bought together.</b> '+esc(FAMILY.t)+' — $'+FAMILY.p.toFixed(2)+'. The holder handles chew time; the Freeze Bowl handles the other kind of busy.'+
     '<div><button class="cw-btn" style="margin-top:10px;padding:10px 18px;font-size:15px" data-cart="'+FAMILY.vid+'">Add the Family Bundle</button></div></div>':'')+
   '<div class="cw-nav"><button class="cw-link" data-act="back">&lsaquo; Change an answer</button><span></span></div></div>';
}

body.addEventListener("click",function(e){
  var t=e.target.closest("[data-act],[data-pick],[data-color],[data-cart]"); if(!t)return;
  if(t.hasAttribute("data-pick")){
    var k=t.getAttribute("data-pick"); S[k]=t.getAttribute("data-val");
    var sib=body.querySelectorAll('[data-pick="'+k+'"]');
    for(var i=0;i<sib.length;i++) sib[i].classList.remove("on");
    t.classList.add("on");
    var n=body.querySelector('[data-act="next"]');
    if(n) n.disabled = (step===2) ? !(S.chew&&S.thick) : !S.power;
    return;
  }
  if(t.hasAttribute("data-color")){S.color=+t.getAttribute("data-color");stepResult();return;}
  if(t.hasAttribute("data-cart")){addToCart(+t.getAttribute("data-cart"),t);return;}
  var a=t.getAttribute("data-act");
  if(a==="next"||a==="skip"){step++;render();}
  else if(a==="back"){step=Math.max(0,step-1);render();}
});

function addToCart(id,btn){
  var old=btn.innerHTML; btn.innerHTML="Adding…";
  fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},
    body:JSON.stringify({items:[{id:id,quantity:1}]})})
  .then(function(r){if(!r.ok)throw 0;return r.json()})
  .then(function(){btn.innerHTML="✓ Added to cart";
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    setTimeout(function(){btn.innerHTML=old},2400);})
  .catch(function(){btn.innerHTML="Preview mode — variant "+id;
    setTimeout(function(){btn.innerHTML=old},2600);});
}
document.getElementById("cwReset").addEventListener("click",function(){
  S={breed:null,weight:null,power:null,chew:null,thick:null,dogs:1,color:0};step=0;render();
  document.getElementById("finder").scrollIntoView({behavior:"smooth",block:"start"});
});
render();

/* --- chart hover layer --- */
var plot=document.getElementById("cwPlot"), tip=document.getElementById("cwTip");
if(plot&&tip){
  plot.addEventListener("mousemove",function(e){
    var m=e.target.closest("[data-tip]");
    if(!m){tip.className="cw-tip";return;}
    var pr=plot.getBoundingClientRect(), mr=m.getBoundingClientRect();
    tip.textContent=m.getAttribute("data-tip");
    tip.style.left=(mr.left-pr.left+mr.width/2)+"px";
    tip.style.top=(mr.top-pr.top)+"px";
    tip.className="cw-tip on";
  });
  plot.addEventListener("mouseleave",function(){tip.className="cw-tip"});
}
})();
